import { render } from "./PerformaAppraisal.vue?vue&type=template&id=ba52e130"
import script from "./PerformaAppraisal.vue?vue&type=script&lang=js"
export * from "./PerformaAppraisal.vue?vue&type=script&lang=js"

import "./PerformaAppraisal.vue?vue&type=style&index=0&id=ba52e130&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__